import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';

/** Closed ring [lng, lat][] (last point may duplicate first). Shared by 2D Deck and Cesium Entity. */
export interface MapAnnotationsState {
  drawnPolygonRing: [number, number][] | null;
}

const initialState: MapAnnotationsState = {
  drawnPolygonRing: null,
};

const annotationsSlice = createSlice({
  name: 'annotations',
  initialState,
  reducers: {
    setDrawnPolygonRing(state, action: PayloadAction<[number, number][] | null>) {
      state.drawnPolygonRing = action.payload;
    },
    clearDrawnPolygon(state) {
      state.drawnPolygonRing = null;
    },
  },
});

export const { setDrawnPolygonRing, clearDrawnPolygon } = annotationsSlice.actions;
export default annotationsSlice.reducer;
